import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { HiOutlineDocumentText } from "react-icons/hi";
import { CustomButton } from "../../atoms/CustomButton";

const DashboardNotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-[calc(100vh-128px)] bg-gray-100 px-8 py-12 flex flex-col justify-center items-center">
      <div className="max-w-6xl w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <div className="flex flex-col justify-center items-start space-y-6">
            <div className="space-y-4">
              <div className="inline-flex items-center px-3 py-1 bg-blue-100 text-blue-600 text-sm font-semibold font-figtree rounded-full uppercase tracking-wide">
                <HiOutlineDocumentText className="w-4 h-4 mr-2" />
                {t("notFound.errorCode")}
              </div>

              <div className="space-y-3">
                {/* design-ok: hero d'affichage d'une page 404 plein ecran, taille volontaire */}
                <h1 className="text-4xl lg:text-5xl font-bold font-figtree text-gray-900 leading-tight">
                  {t("notFound.pageTitle")}
                </h1>
                <p className="text-gray-500 text-lg font-normal font-figtree leading-relaxed">
                  {t("notFound.description")}
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <Link to="/control-panel">
                <CustomButton
                  variant="primary"
                  title={t("notFound.goBackButton")}
                  className="px-6 py-3"
                />
              </Link>
              <button
                onClick={() => window.history.back()}
                className="px-6 py-3 text-gray-600 hover:text-gray-800 font-medium font-figtree transition-colors"
              >
                ← {t("notFound.goBack")}
              </button>
            </div>
          </div>

          <div className="flex justify-center items-center">
            <div className="w-full max-w-md">
              <img
                className="w-full h-auto"
                src="https://cdn.1cdn.app/application/UMD/23030509171580_UMD_Error404.svg"
                alt={t("notFound.imageAlt") as string}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardNotFound;
